export class SmoothScroll {
    /**
     * The button that's clicked.
     */
    public $button: JQuery<HTMLDivElement>;

    /**
     * Body element of the page.
     */
    public $body: JQuery<HTMLDivElement>;

    /**
     * Header element of the page.
     */
    public $header: JQuery<HTMLDivElement>;

    constructor() {
        this.$button = $('a[href^="#"]');
        this.$body = $('body');
        this.$header = $('header');

        this.$button.on('click', (e) => this.scrollToItem(e));
    }

    /**
     * Find element with id of clicked buttons' href.
     */
    public scrollToItem(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const target: JQuery<HTMLElement> = $(e.target.getAttribute('href'));

        let headerHeight: number = this.$header.outerHeight();

        if (this.$body.hasClass('admin-bar')){
            headerHeight += 32;
        }

        this.$body.animate({scrollTop: target.offset().top - headerHeight}, 600);
    }
}